// https://reacttraining.com/react-router/web/example/modal-gallery
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-reboot.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, {useEffect, useState} from 'react';
import Turnstile from "react-turnstile";
// import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client';
import './Pages/css/index.css';
import { applyStoredTheme } from './theme';
import App from './App';

// Ensure data-theme matches localStorage even if the inline HTML script was skipped
applyStoredTheme();
//import MainMenu from './MainMenu';
//import HeaderApp from './header';
// import { register, unregister } from './registerServiceWorker'; // service-worker
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// eslint-disable-next-line
import {
	BrowserRouter as Router,
	Switch, // eslint-disable-line
	Route, // eslint-disable-line
	Link // eslint-disable-line
} from 'react-router-dom';
import 'bootstrap';
//import 'bootstrap/dist/css/bootstrap.css';
import store from 'store2';
const refConst = require("./constants.js").v

/**
 * Clears service-worker caches, then runs an optional callback (typically a page reload).
 * Used when the user explicitly chooses to apply an update.
 */
var fncCtnNewUpdate = (callback) => {
	setTimeout(() => {
		caches.keys().then(function(names) {
			for (let name of names) caches.delete(name);
			if (callback) callback();
			console.info('Website need to be refreshed');
		});
	}, 2000)
};

/**
 * Holds the waiting service-worker registration until App mounts / the user reloads.
 * Avoid remounting React here — that previously wiped in-progress work like an auto-reload.
 */
var pendingSwRegistration = null;

/**
 * Called by the service worker when a new build is available.
 * Does NOT reload the page; notifies App so it can show an update banner.
 */
var fncCtnNewUpdateModal = (registration) => {
	console.info('New app update available; waiting for user to reload.');
	pendingSwRegistration = registration || null;
	// Expose for App in case the event fired before the listener was attached
	window.__eioPendingSwUpdate = pendingSwRegistration;
	window.dispatchEvent(new CustomEvent('eio-app-update-available', {
		detail: pendingSwRegistration
	}));
};

const app = (
	<Router>
		<Route render={(props) => <App {...props} cacheRefresh={fncCtnNewUpdate} needReload={false}/>}/>
	</Router>
);

const clearanceRequest = async (payload) => {
	const response = await fetch(refConst.turnstileClearanceBackend, {
		method: 'POST',
		credentials: 'include',
		cache: 'no-store',
		body: new URLSearchParams(payload),
	});
	return response.ok && (await response.json()).authorized === true;
};

function TurnstileGate() {
	const [state, setState] = useState('checking');

	useEffect(() => {
		let active = true;
		clearanceRequest({action: 'status'})
			.then((authorized) => active && setState(authorized ? 'authorized' : 'challenge'))
			.catch(() => active && setState('challenge'));
		return () => { active = false; };
	}, []);

	if(state === 'authorized')
		return app;

	if(state === 'checking')
		return <div aria-live="polite" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>Checking security clearance…</div>;

	return <Turnstile
		sitekey="0x4AAAAAABg8uedpBjOPHp4m"
		onVerify={async (token) => {
			try {
				if(await clearanceRequest({action: 'verify', token}))
					setState('authorized');
			} catch (error) {
				console.error('Unable to save Turnstile clearance.', error);
			}
		}}
		onExpire={() => setState('challenge')}
		onError={() => setState('challenge')}
		style={{
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			height: '100vh'
		}}
	/>;
}

createRoot(document.getElementById('root')).render(refConst.dev ? app : <TurnstileGate/>);

/* ReactDOM.render((
	<Router>
		<Route render={(props) => <App {...props} cacheRefresh={fncCtnNewUpdate} needReload={false}/>}/>
	</Router>
), document.getElementById('root')); */

//ReactDOM.render(<HeaderApp />, document.getElementById('header'));
//ReactDOM.render(<MainMenu />, document.getElementById('mainMenu'));
/*
ReactDOM.render( () => {
	<ul className="nav navbar-nav navbar-right">{(new MainMenu()).getLink().menu}</ul>
}, document.getElementById('navbarMenu'));
*/

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
//// serviceWorkerRegistration.unregister();

// console.warn("TEST", process);
serviceWorkerRegistration.register({
	onUpdate: fncCtnNewUpdateModal,
});
// register(fncCtnNewUpdateModal);
